import Vector1 from "../../assets/images/Vector1.png";
import Banner1 from "./BannerDesign/Banner1";
import Banner2 from "./BannerDesign/Banner2";
import Banner3 from "./BannerDesign/Banner3";

export default function BannerLayoutRenderer({
  layout,
  showFormOnly,
  showLayoutOnly,
  banner1Data,
  setBanner1Data,
  banner2Data,
  setBanner2Data,
  banner3Data,
  setBanner3Data,
}) {
  const layoutMap = {
    banner1: {
      form: <Banner1Form data={banner1Data} setData={setBanner1Data} />,
      layout: (
        <BannerLayout
          layout="banner1"
          mainText={banner1Data?.title || ""}
          priceText={banner1Data?.price || ""}
          rightText={banner1Data?.price || ""}
        />
      ),
    },
    banner2: {
      form: <Banner2Form data={banner2Data} setData={setBanner2Data} />,
      layout: (
        <BannerLayout
          layout="banner2"
          items={banner2Data} // ✅ 리스트 넘김
        />
      ),
    },
    banner3: {
      form: <Banner3Form data={banner3Data} setData={setBanner3Data} />,
      layout: (
        <BannerLayout
          layout="banner3"
          mainText={banner3Data?.title || ""}
          priceText={banner3Data?.title || ""}
          rightText={banner3Data?.title || ""}
        />
      ),
    },
  };

  const current = layoutMap[layout];

  if (!current) {
    return <div className="text-center text-gray-500 p-4">no</div>;
  }

  if (showFormOnly) return current.form;
  if (showLayoutOnly) return current.layout;

  return (
    <div className="flex gap-6">
      <div className="w-1/2 space-y-4">{current.form}</div>
      <div className="w-1/2">{current.layout}</div>
    </div>
  );
}

function BannerLayout({ layout, mainText, priceText, rightText, items = [] }) {
  const bannerData = {
    rank: "1st",
    title: mainText,
    subtitle: rightText,
    ctaText: mainText,
    image: Vector1,
    bgimage:
      "https://i.pinimg.com/736x/09/3d/e8/093de8e08ce331dc133eb3bb39f0d3fb.jpg",
    themeColor: "#231942",
  };

  const LayoutComponent = {
    banner1: Banner1,
    banner2: Banner2,
    banner3: Banner3,
  }[layout];

  if (!LayoutComponent) {
    return <div className="text-center text-red-500">Invalid layout</div>;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-8 p-8">
      <div className="flex">
        <LayoutComponent {...bannerData} items={items} />
      </div>
      <div className="flex gap-8">
        <LayoutComponent layoutType="layout2" {...bannerData} items={items} />
        <LayoutComponent layoutType="layout3" {...bannerData} items={items} />
      </div>
    </div>
  );
}

function Banner1Form({ data, setData }) {
  return (
    <div className="space-y-2">
      <input
        placeholder="Title"
        value={data.title}
        onChange={(e) => setData({ ...data, title: e.target.value })}
        className="border p-2 w-full rounded"
      />
      <input
        placeholder="Price"
        value={data.price}
        onChange={(e) => setData({ ...data, price: e.target.value })}
        className="border p-2 w-full rounded"
      />
    </div>
  );
}

function Banner2Form({ data, setData }) {
  const updateItem = (index, key, value) => {
    const newItems = [...data];
    newItems[index][key] = value;
    setData(newItems);
  };

  const addItem = () => {
    if (data.length < 7) {
      setData([...data, { title: "", price: "" }]);
    }
  };

  return (
    <div className="space-y-4">
      {data.map((item, idx) => (
        <div key={idx} className="flex gap-2">
          <input
            placeholder="Title"
            value={item.title}
            onChange={(e) => updateItem(idx, "title", e.target.value)}
            className="border p-2 w-full rounded"
          />
          <input
            placeholder="Price"
            value={item.price}
            onChange={(e) => updateItem(idx, "price", e.target.value)}
            className="border p-2 w-full rounded"
          />
        </div>
      ))}
      {data.length < 5 && (
        <button
          onClick={addItem}
          className="px-4 py-2 bg-gray-100 w-full text-blue-600 font-bold rounded"
        >
          + List
        </button>
      )}
    </div>
  );
}

function Banner3Form({ data, setData }) {
  return (
    <div>
      <input
        placeholder="Title"
        value={data.title}
        onChange={(e) => setData({ ...data, title: e.target.value })}
        className="border p-2 w-full rounded"
      />
    </div>
  );
}
